module.exports = __webpack_public_path__ + "img/file-image.214809c7.svg";